export function projectSuggestionEventProps(suggestion: {
  projectId: string | null;
}) {
  return {
    suggestion_kind: suggestion.projectId === null ? 'new' : 'existing',
  };
}
